"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CountryLocaleFinder = void 0;
const country_locale_map_1 = __importDefault(require("country-locale-map"));
class CountryLocaleFinder {
    static countryLocale(locale) {
        const countryLocale = country_locale_map_1.default.getCountryByAlpha2(locale.toUpperCase());
        if (!countryLocale)
            return null;
        return countryLocale.default_locale.replace('_', '-');
    }
    static defaultCountryLocale(locale) {
        if (!locale)
            return 'en-US';
        return CountryLocaleFinder.countryLocale(locale) || 'en-US';
    }
}
exports.CountryLocaleFinder = CountryLocaleFinder;
//# sourceMappingURL=countryLocaleFinder.js.map